import actions from './actions';
import thunks from './thunks';

export default {
  actions,
  thunks,
};
